import { Component, Input, ViewChild } from '@angular/core';
import { Slides } from 'ionic-angular';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { ToolsProvider } from '../../providers/tools/tools';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { TripService } from '../../providers/trip-service/trip-service';

@Component({
  selector: 'places-slider',
  templateUrl: 'places-slider.html',
})
export class PlacesSliderComponent {
  log = debug('app:PlacesSliderComponent');

  @ViewChild(Slides) slides: Slides;
  @ViewChild('sliderContainer') sliderContainer;
  @Input() smallCards = false;
  @Input() initialSlide = 0;
  @Input() places = [];
  @Input() distanceFrom;
  @Input() clickable = true;
  @Input() noneFoundMessage = 'No Places Found';
  @Input() selectPlacesButton = true;
  @Input() disableFirstZoom = false;
  inited = false;

  placesList = [];

  slidesToLoad: any = 10;
  currentIndex = 0;
  placesListSize = 0;

  subs = [];

  constructor(
    public placesService: PlaceServiceProvider,
    public tripService: TripService,
    public tools: ToolsProvider
  ) {
    this.log('constructed');
  }

  ngOnInit() {
    this.log('slider initial slides: ', this.places);

    this.currentIndex = this.slides.getActiveIndex() || 0;
    this.loadGoogleData(this.initialSlide);

    this.updateList();

    setTimeout(() => {
      this.slideChanged();
    });
  }
  private updateList() {
    this.placesList = this.places;
    this.placesListSize = _.size(this.placesList);
  }

  ngOnDestroy() {
    _.each(this.subs, fn => {
      // works for event emitter and observables
      if (fn && fn.unsubscribe) {
        fn.unsubscribe();
      } else {
        fn && fn();
      }
    });
  }

  emitTogglePlaceMenu(view) {
    this.log('toggling palce menu', view);
    this.tools.emit('togglePlacesMenu', view);
  }

  private changeNearbyPlaceSlider() {
    this.log('changing nearby slider: ', _.get(this.slides, 'id'));
    this.loadGoogleDataNearbyPlace(this.slides.getActiveIndex(), this.places);
  }

  slideChanged(changeZoom?) {
    this.log('changing slide for sliderIndex: ', _.get(this.slides, 'id'));
    if (_.get(this.placesList[0], 'nearbyPlace')) {
      this.changeNearbyPlaceSlider();
      return;
    }

    this.log('slider event', changeZoom);
    let currentIndex = this.slides.getActiveIndex() || 0;

    // ionic inits 0 before the one we ask for
    if (!this.inited && currentIndex !== this.initialSlide) {
      return;
    }

    this.inited = true;
    this.currentIndex = currentIndex;
    const activePlace = this.placesService.places[currentIndex];
    this.log('active place', currentIndex, activePlace);
    if (!activePlace) {
      return;
    }

    $(`.MapMarker-${activePlace._id}`).click();
    this.tripService.activateMarker(activePlace._id);

    if (this.disableFirstZoom && this.currentIndex === 0) {
      this.log('not zooming on first');
    } else {
      this.tripService.getMapCurrentZoom().then(zoom => {
        const z: any = zoom;
        let currentZoom = Math.max(z, 5);

        this.log('zoom', currentZoom, activePlace);
        this.tripService.getMap().then(m => {
          m.flyTo({
            center: activePlace.location.coordinates,
            offset: this.mapOffset(),
            zoom: currentZoom,
          });
        });
      });
    }

    this.loadGoogleData(currentIndex);
  }

  private mapOffsetY() {
    return $(_.get(this.sliderContainer, 'nativeElement')).height() || 0;
  }

  private mapOffset() {
    const ofy = this.mapOffsetY();
    this.log('offset', ofy);
    return [0, -(ofy / 2)];
  }

  slideToSlide(markerId) {
    _.each(this.placesService.places, (place, idx) => {
      if (place._id === markerId) {
        this.log('places for slide to', idx);
        try {
          this.slides.slideTo(_.parseInt(String(idx)), 500);
        } catch (e) {
          this.log(`error slide to slide:  ${e}`);
        }
      }
    });
  }

  private loadGoogleData(n) {
    if (this.smallCards) {
      return false;
    }
    this.log('getting google data');
    this.placesService.getGooglePlaceDataForNext(n, 2, this.places);
  }

  private loadGoogleDataNearbyPlace(n, places) {
    if (this.smallCards) {
      return false;
    }
    this.log('getting google data for nearby places');
    this.placesService.getGooglePlaceDataForNext(n, 2, places);
  }
}



// WEBPACK FOOTER //
// ./src/components/places-slider/places-slider.ts